import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import Banner from "../comp/comm/Banner";
import { Link } from "react-router-dom";
import { reqData } from "../js/server";
import MainBoard from "./comm/MainBoard";
import DragsPop from "./comm/DragsPop";

function MainContents(props) {
  const dispatch = useDispatch();
  const [banners, setBanners] = useState([]);
  const [infos, setInfos] = useState([]);
  const [news, setNews] = useState([]);
  const [events, setEvents] = useState([]);
  const [gallerys, setGallerys] = useState([]);
  const [isPopup, setIsPopup] = useState(true);

  const fetchInfoData = () => {
    const jsonData = {
      servicename: "MainBoard",
      kind: "info",
    };
    dispatch({ type: "loadingChange", payload: true });
    reqData(jsonData)
      .then((res) => {
        if (res.data.result === "OK") {
          setInfos(res.data.jsonData);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchNewsData = () => {
    const jsonData = {
      servicename: "MainBoard",
      kind: "news",
    };

    dispatch({ type: "loadingChange", payload: true });
    reqData(jsonData)
      .then((res) => {
        if (res.data.result === "OK") {
          setNews(res.data.jsonData);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchEventsData = () => {
    const jsonData = {
      servicename: "MainBoard",
      kind: "event",
    };

    dispatch({ type: "loadingChange", payload: true });
    reqData(jsonData)
      .then((res) => {
        if (res.data.result === "OK") {
          setEvents(res.data.jsonData);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchGallerysData = () => {
    const jsonData = {
      servicename: "MainBoard",
      kind: "gallery",
    };

    dispatch({ type: "loadingChange", payload: true });
    reqData(jsonData)
      .then((res) => {
        if (res.data.result === "OK") {
          setGallerys(res.data.jsonData);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchBannerData = () => {
    const jsonData = {
      servicename: "BannerList",
    };

    reqData(jsonData)
      .then((res) => {
        if (res.data.result === "OK") {
          setBanners(res.data.jsonData);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({ type: "loadingChange", payload: false });
      });
  };

  useEffect(
    () => {
      dispatch({ type: "pageChange", payload: "index" });
      dispatch({ type: "loadingChange", payload: true });

      //공지사항 데이터 불러오기
      fetchInfoData();
      //자동차정비뉴스 데이터 불러오기
      fetchNewsData();
      //경조사 데이터 불러오기
      fetchEventsData();
      //포토갤러리 데이터 불러오기
      fetchGallerysData();
      //Partners Banner 불러오기
      fetchBannerData();
    },
    // eslint-disable-next-line
    []
  );

  return (
    <>
      {isPopup && <DragsPop setIsPopup={setIsPopup} />}

      <section className="banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-xl-7">
              <div className="block">
                <div className="divider mb-3"></div>
                <span className="text-sm letter-spacing banner-text-sm">
                  강원특별자치도자동차검사정비사업조합
                </span>
                <h2 className="mb-3 mt-3 kbiz-company">
                  친환경 자동차 문화의 선두주자
                </h2>

                <p className="mb-4 pr-5">
                  <span className="banner-text-sm">
                    안전과 신뢰의 자동차 정비 약속
                  </span>
                  <br />
                  <span className="banner-text-sm">
                    강원특별자치도자동차검사정비사업조합과 함께 창조하는 미래
                  </span>
                </p>
                <div className="btn-container ">
                  <Link
                    to="/JoinStep01"
                    className="btn btn-main-2 btn-icon btn-round-full"
                  >
                    조합원 가입하기
                    <i className="icofont-simple-right ml-2  "></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="row pb-5">
            <div className="col-lg-4 col-12">
              <MainBoard kind="info" items={infos} />
            </div>
            <div className="col-lg-4 col-12">
              <MainBoard kind="news" items={news} />
            </div>
            <div className="col-lg-4 col-12">
              <MainBoard kind="event" items={events} />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-8">
              <MainBoard kind="gallery" items={gallerys} />
            </div>
            <div className="col-12 col-lg-4">
              <MainBoard kind="union_mem" />
            </div>
          </div>
        </div>
      </section>

      <section className="section service gray-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 text-center">
              <div className="section-title">
                <h2>Since 1967</h2>
                <div className="divider mx-auto my-4"></div>
                <p>
                  강원특별자치도자동차검사정비사업조합은 친환경 자동차 시대에
                  부응하며, 국민의 안전과 복리 증진을 위해 노력합니다. 지속적인
                  교육과 협력을 통해 조합원의 경제적 지위향상과 지역 사회의 균형
                  있는 발전을 추구합니다.
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-6">
              <Link to="/History">
                <div className="service-item mb-4">
                  <div className="icon d-flex align-items-center">
                    <i className="icofont-history icon-main-history-size"></i>
                    <h4 className="mt-3 mb-3">연혁</h4>
                  </div>

                  <div className="content">
                    <p className="mb-4">
                      1967년도 설립되어 정비업의 발전과 조합원 복지증진을 위해
                      일하고 있습니다.
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6">
              <Link to="/Directions">
                <div className="service-item mb-4">
                  <div className="icon d-flex align-items-center">
                    <i className="icofont-map-pins icon-main-history-size"></i>
                    <h4 className="mt-3 mb-3">찾아오시는 길</h4>
                  </div>
                  <div className="content">
                    <p className="mb-4">
                      강원특별자치도 춘천시 동면 만천로 57,
                      <br />
                      약도는 클릭해 주세요.
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6">
              <Link to="/UnionMem">
                <div className="service-item mb-4">
                  <div className="icon d-flex align-items-center">
                    <i className="icofont-business-man icon-main-history-size"></i>
                    <h4 className="mt-3 mb-3">이사장 인사말</h4>
                  </div>
                  <div className="content">
                    <p className="mb-4">
                      강원특별자치도자동차검사정비사업조합을 대표하여 조합원
                      여러분께 인사드립니다.
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6">
              <Link to="/Articles">
                <div className="service-item mb-4">
                  <div className="icon d-flex align-items-center">
                    <i className="icofont-ebook icon-main-history-size"></i>
                    <h4 className="mt-3 mb-3">조합정관</h4>
                  </div>

                  <div className="content">
                    <p className="mb-4">
                      조합의 정체성과 고유한 특징을 담은 근본 규칙을 살펴봅니다.
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6">
              <Link to="/ABoardList?kind=joboffer">
                <div className="service-item mb-4">
                  <div className="icon d-flex align-items-center">
                    <i className="icofont-search-job icon-main-history-size"></i>
                    <h4 className="mt-3 mb-3">구인정보</h4>
                  </div>
                  <div className="content">
                    <p className="mb-4">
                      당신의 기업에 완벽한 인재를 찾으세요. 조합이 함께합니다.
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6">
              <Link to="/ABoardList?kind=jobsearch">
                <div className="service-item mb-4">
                  <div className="icon d-flex align-items-center">
                    <i className="icofont-search-job icon-main-history-size"></i>
                    <h4 className="mt-3 mb-3">구직정보</h4>
                  </div>
                  <div className="content">
                    <p className="mb-4">
                      여러분의 미래를 위한 기회가 여기에 있습니다.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Banner banners={banners} />
    </>
  );
}

//store(redux 이용) state를 이용하기 위한 설정
export default MainContents;
